module.exports = __webpack_public_path__ + "static/media/footer-web.daf5d70f.png";